import jwt_decode from "jwt-decode";
import AxiosLib from "../../Library/AxiosLib";
import AxiosLibWithHeader2 from "../../Library/AxiosLibWithHeader2";
import axios from "axios";


var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

const Request2Estes = async (param) => {
    const keys = {
        AppId: AuthDecode.AppID,
        AppEnv: AuthDecode.AppEnv,
        Secretkey: AuthDecode.secretkey,
    };

    const postData = {
        keys: keys,
        body: param,
    };

    const results = await AxiosLibWithHeader2(
        postData,
        "app/api/req-module"
    ).then((response) => {
        if (response.error) {
            return { loading: false, data: [], message: response.error };
        } else if (response.result && response.result === "error") {
            const code_api = response?.response?.message?.code || "";
            const code_msg = response?.response?.message?.user || "";
            return {
                loading: false,
                data: [],
                message:
                    code_api === "900908"
                        ? "Access to the API service is restricted for this application."
                        : code_msg,
            };
        } else if ("message" in response.response) {
            const msg = response.response.message.user;
            return { loading: false, data: [], message: msg };
        } else {
            const data = response.response.data;
            return { loading: false, data: data, message: "" };
        }
    });

    return results;
};

const GET_ACTIVE_ACAD = async (param) => {
    const param_post = {
        parameters: param,
        target_data: "GET_ACTIVE_ACAD",
    };
    const results = await Request2Estes(param_post);

    return results;
};

const GET_DETAIL_STUDENT = async (param) => {
    const param_post_status = {
        parameters: param,
        target_data: "GET_STUDENT_STATUS",
    };
    const param_post_bio = {
        parameters: param,
        target_data: "GET_STUDENT_DATA_M",
    };
    const [r_std_status, r_std_bio] = await Promise.all([
        Request2Estes(param_post_status),
        Request2Estes(param_post_bio)
    ]);

    if (r_std_status.message || r_std_bio.message) {
        return { loading: false, data: [], message: r_std_status.message || r_std_bio.message }
    }

    const combined_data = {
        ...r_std_bio?.data,
        bio_id: r_std_bio?.data?.id,
        ...r_std_status?.data
    }

    return { loading: false, data: combined_data, message: "" }
};

const GET_ENROLLMENT_PROCESS = async (param) => {
    const param_post = {
        parameters: param,
        target_data: "GET_ENROLLMENT_PROCESS",
    };
    const results = await Request2Estes(param_post);

    return results;
};


const FetchMenu = (setMenu) => {
    setMenu({ loading: true, message: "", data: [] })
    var dataParam = {
        UserID: AuthDecode.currentData.entityid,
        Type: 1,
        ParentID: 0,
        RoleID: AuthDecode.currentData.roleid,
    };
    if (AuthDecode.currentData.empid) {
        dataParam.EmpID = AuthDecode.currentData.empid;
    }
    AxiosLib(dataParam, "mc/api/action/fetch/navigation").then(
        (response) => {
            if (response.error) {
                setMenu({ loading: false, message: response.error, data: [] })
            } else {
                if (response.data) {
                    let results = response.data;
                    setMenu({ loading: false, message: "", data: results })
                } else {
                    setMenu({ loading: false, message: "No record found", data: [] })
                }
            }
        }
    )
}

const CheckIsLais = (setLais, urlsurvey) => {
    setLais({ loading: true, data: 0, message: "" })
    var keys = {
        AppId: AuthDecode.AppID,
        AppEnv: AuthDecode.AppEnv,
        Secretkey: AuthDecode.secretkey,
    };
    var body = {
        parameters: {
            studentid: AuthDecode.currentData.entityid,
        },
        target_data: "ASC_IS_LAISREQUIRED",
    };
    const postData = {
        keys: keys,
        body: body,
    };

    AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
        if (response.error) {
            setLais({ loading: false, data: 0, message: response.error })
        } else if ("message" in response.response) {
            setLais({ loading: false, data: 0, message: response.response.message.user })
        } else if (response.result === "success") {
            if (response.response.data > 0) {
                var value = response.response.data;
                if (value === 1) {
                    setLais({ loading: false, data: value, message: "" })
                    setTimeout(() => {
                        window.location.replace(urlsurvey);
                    }, 2000);
                } else {
                    setLais({ loading: false, data: 0, message: "" })
                }
            } else {
                setLais({ loading: false, data: 0, message: "" })
            }
        } else {
            setLais({ loading: false, data: 0, message: "" })
        }
    });
};

const CheckSurvey = (setSurvey, urlsurvey, studentid) => {
    setSurvey({ loading: true, data: 0, message: "" });
    var keys = {
        AppId: AuthDecode.AppID,
        AppEnv: AuthDecode.AppEnv,
        Secretkey: AuthDecode.secretkey,
    };
    var body = {
        parameters: {
            studentid: AuthDecode.currentData.entityid,
        },
        target_data: "ASC_IS_INTERNSHIPSURVEYREQUIRED",
    };
    const postData = {
        keys: keys,
        body: body,
    };

    return AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
        if (response.error) {
            setSurvey({ loading: false, data: 0, message: response.error });
        } else if ("message" in response.response) {
            setSurvey({ loading: false, data: 0, message: response.response.message.user });
        } else if (response.result === "success") {
            if (Object.values(response.response.data).length > 0) {
                let res = response.response.data;
                if (res.required === 1) {
                    let uri = res.ddegree === 1
                        ? urlsurvey + "internshipDouble?pg=" + studentid
                        : urlsurvey + "internshipSingle?pg=" + studentid;

                    setSurvey({ loading: false, data: res.required, message: "", uri: uri });
                } else {
                    setSurvey({ loading: false, data: 0, message: "" });
                }
            } else {
                setSurvey({ loading: false, data: 0, message: "" });
            }
        } else {
            setSurvey({ loading: false, data: 0, message: "" });
        }
    });
};

const GET_STUDENT_STATUS = (setData, setCurrentStatus, studentid) => {
    setData({ loading: true, data: [], message: "" })
    var keys = {
        AppId: AuthDecode.AppID,
        AppEnv: AuthDecode.AppEnv,
        Secretkey: AuthDecode.secretkey,
    };
    var body = {
        parameters: {
            studentid: studentid,
        },
        target_data: "GET_STUDENT_STATUS",
    };
    const postData = {
        keys: keys,
        body: body,
    };

    AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
        //console.log(response);
        if (response.error) {
            setData({ loading: false, data: [], message: response.error })
        } else if ("message" in response.response) {
            setData({ loading: false, data: [], message: response.response.message.user })
        } else if (response.result === "success") {
            if (Object.values(response.response.data).length > 0) {
                // console.log(response.response.data);
                setData({ loading: false, data: response.response.data, message: "" })
                const currStatus = response.response.data?.status?.id || "";
                setCurrentStatus(currStatus);
            } else {
                setData({ loading: false, data: [], message: "" })
            }
        } else {
            setData({ loading: false, data: [], message: "" })
        }
    });
};

const GET_CPDP_SCORE_SEMESTER = async (param) => {
    const param_post = {
        parameters: param,
        target_data: "GET_CPDP_SCORE_SEMESTER",
    };
    const results = await Request2Estes(param_post);

    return results;
};

const GET_CPDP_SCORE_CATEGORY = async (param) => {
    const param_post = {
        parameters: param,
        target_data: "GET_CPDP_SCORE_CATEGORY",
    };
    const results = await Request2Estes(param_post);

    return results;
};



export { Request2Estes, GET_ACTIVE_ACAD, FetchMenu, CheckIsLais, CheckSurvey, GET_STUDENT_STATUS, GET_DETAIL_STUDENT, GET_ENROLLMENT_PROCESS, GET_CPDP_SCORE_CATEGORY, GET_CPDP_SCORE_SEMESTER }